import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = {
  for: "email",
  class: "form-label"
}
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "form-error-text" }
const _hoisted_6 = { class: "pt-4 pb-2 flex items-center justify-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_back_button = _resolveComponent("base-back-button")!
  const _component_base_form_submit = _resolveComponent("base-form-submit")!
  const _component_base_shadow_card = _resolveComponent("base-shadow-card")!
  const _component_layouts_guest = _resolveComponent("layouts-guest")!

  return (_openBlock(), _createBlock(_component_layouts_guest, null, {
    default: _withCtx(() => [
      _createVNode(_component_base_shadow_card, {
        title: _ctx.t('forgot_password.title')
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.t('forgot_password.send_link_messeage')), 1),
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.t('word.email')), 1),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                id: "email",
                name: "email",
                type: "email",
                placeholder: _ctx.t('word.email'),
                class: _normalizeClass(`form-input mb-1 ${_ctx.errors['email'] ? 'border-red-500' : ''}`)
              }, null, 10, _hoisted_4), [
                [_vModelText, _ctx.email]
              ]),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.errors['email']), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_base_back_button),
              _createVNode(_component_base_form_submit, { disabled: _ctx.btnDisabled }, null, 8, ["disabled"])
            ])
          ], 32)
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    _: 1
  }))
}